import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-gray-900 text-white py-8" data-id="element-30">
      <div className="container mx-auto px-4 md:px-8" data-id="element-31">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-32">
          <div className="mb-4 md:mb-0" data-id="element-33">
            <h3 className="text-xl font-bold mb-2" data-id="element-34">SleepEase Knee Support</h3>
            <p className="text-lg text-gray-300" data-id="element-35">
              Helping you sleep better since 2023
            </p>
          </div>
          <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-36">
            <a href="https://www.vitalrelief.co.uk/products/vital-relief™-sleep-through-the-night-knee-sleeve" className="text-xl text-gray-300 hover:text-white" data-id="element-37">
              Privacy Policy
            </a>
            <a href="https://www.vitalrelief.co.uk/products/vital-relief™-sleep-through-the-night-knee-sleeve" className="text-xl text-gray-300 hover:text-white" data-id="element-38">
              Terms of Service
            </a>
            <a href="https://www.vitalrelief.co.uk/products/vital-relief™-sleep-through-the-night-knee-sleeve" className="text-xl text-gray-300 hover:text-white" data-id="element-39">
              Contact Us
            </a>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-700" data-id="element-40">
          <p className="text-lg text-gray-300 text-center" data-id="element-41">
            &copy; {new Date().getFullYear()} SleepEase Knee Support. All rights
            reserved.
          </p>
          <p className="text-base text-gray-400 text-center mt-2" data-id="element-42">
            *Individual results may vary. These statements have not been
            evaluated by the Medicines and Healthcare products Regulatory Agency
            (MHRA).
          </p>
        </div>
      </div>
    </footer>;
};